/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input
          size="small"
          v-model="goodName"
          placeholder="请输入商品"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          size="small"
          v-model="goodsStatus"
          placeholder="请选择商品类型"
        >
          <el-option
            v-for="type in goodsTypeList"
            :label="type.key"
            :value="type.value"
            :key="type.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
        >搜索
        </el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addGoods"
        >导入商品
        </el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-upload2"
          @click="exportGoods"
        >导出商品
        </el-button
        >
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addNewGoods"
        >添加商品
        </el-button
        >
      </el-form-item>

    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="goodsList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column
        prop="imageUrl"
        label="图片"
        width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.imageUrl"
            alt="头像"
            style="max-width: 100%; max-height: 80px"
          />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="costPrice" label="成本" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="salePrice" label="售价" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="vipPrice" label="会员价" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="barcode" label="条码" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="stock"
        label="库存"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
          >编辑
          </el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="deleteGood(scope.$index, scope.row)"
          >删除
          </el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog('editForm')"
    >
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="图片">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                headers="{ 'token': localStorage.getItem('token') }"
                :on-change="handleChange"
                :on-success="handlePictureSuccess"
                :on-error="handleError"
                :on-remove="handlePictureRemove"
                :file-list="fileList"
                limit="1"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
              <el-input
                size="small"
                v-model="editForm.imageUrl"
                auto-complete="off"
                placeholder="图片"
              ></el-input>
            </el-form-item>
            <el-form-item label="名称">
              <el-input
                size="small"
                v-model="editForm.name"
                auto-complete="off"
                placeholder="名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="成本">
              <el-input
                size="small"
                v-model="editForm.costPrice"
                auto-complete="off"
                placeholder="请输入微信子商户"
              ></el-input>
            </el-form-item>
            <el-form-item label="售价">
              <el-input
                size="small"
                v-model="editForm.salePrice"
                auto-complete="off"
                placeholder="请输入通知回调"
              ></el-input>
            </el-form-item>
            <el-form-item label="会员价">
              <el-input
                size="small"
                v-model="editForm.vipPrice"
                auto-complete="off"
                placeholder="请输入会员价"
              ></el-input>
            </el-form-item>
            <el-form-item label="库存">
              <el-input
                size="small"
                v-model="editForm.stock"
                auto-complete="off"
                placeholder="请输入库存"
              ></el-input>
            </el-form-item>
            <el-form-item label="条码">
              <el-input
                size="small"
                v-model="editForm.barcode"
                auto-complete="off"
                placeholder="条码"
              ></el-input>
            </el-form-item>
            <el-form-item label="预下架">
              <el-select v-model="editForm.preTakedown" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="库存上线">
              <el-input
                size="small"
                v-model="editForm.activityYouHuiPrice"
                auto-complete="off"
                placeholder=""
              ></el-input>
            </el-form-item>
            <el-form-item label="报警库存">
              <el-input
                size="small"
                v-model="editForm.activityYouHuiPrice"
                auto-complete="off"
                placeholder=""
              ></el-input>
            </el-form-item>


            <el-form-item
              v-for="(domain, index) in editForm.yzsGoodsChannelList"
              :label="'商品通道:'"
              :key="domain.key">

              <div style="display: flex;gap: 60px;">
                <div>

                  商品通道：
                  <el-input v-model="domain.channel" placeholder="请选择商品通道" size="mini" style="width: 100px"/>
                  <br/>

                  <!--              <el-select v-model="domain.channel" ref="select" placeholder="请选择商品通道">-->
                  <!--                <el-option-->
                  <!--                  v-for="item in ChannelList"-->
                  <!--                  :key="item"-->
                  <!--                  :label="item"-->
                  <!--                  :value="item">-->
                  <!--                </el-option>-->
                  <!--              </el-select>-->
                  库存：
                  <el-input v-model="domain.stock" placeholder="请输入该通道的商品库存" size="mini"
                            style="width: 100px"/>

                  <br/>

                  是否开启光幕：
                  <el-select v-model="domain.lightCurtains" ref="select" placeholder="请选择" :loading="loadg">
                    <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="parseInt(item.id)">
                    </el-option>
                  </el-select>

                  <br/>

                  <!--              转动时长：-->
                  <!--              <el-input v-model="domain.openTime" placeholder="请输入该通道的转动时长" size="mini" style="width: 100px"/>-->

                </div>

                <el-button @click.prevent="removeDomain(domain)" type="danger" plain>删除</el-button>
              </div>

            </el-form-item>


            <el-button @click="addDomain" type="primary" plain style="margin-bottom: 20px"
            >增加商品通道
            </el-button>


          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm"
        >保存
        </el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加商品库(仅支持EXCEL文件)"
      :visible.sync="addGoodsVisible"
      width="30%"
      :before-close="closeDialog"
      @close="closeDialog('addGoods')"
    >
      <div class="updataBox">
        <br/>
        <el-upload
          class="upload-demo"
          action
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :on-error="handleError"
          :headers="{ 'content-type': 'multipart/form-data', userName: name,
                  storeId: storeId }"
          :http-request="uploadFile"
          :on-change="handleChange"
          :multiple="multiple"
          :limit="1"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            请核对好文件的列名，确保与上传模板的列名保持一致
          </div>
        </el-upload>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button
          type="primary"
          @click="submitAdd"
          v-loading.fullscreen.lock="fullscreenLoading"
        >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {OrderList, OrderRefund, OrderDelete} from "../../api/payMG";
import Pagination from "../../components/Pagination";
import {blobValidate} from "@/utils/ruoyi";
import {saveAs} from "file-saver";

import {
  getGoodsList,
  getGoodsTypeList,
  getGoodsDetail,
  editGoodsInfo,
  addGoodsByBarcode,
  deleteGoods, //删除商品
} from "@/api/api.js";

export default {
  data() {
    return {
      options2: [
        {
          id: 0,
          name: "不开启光幕"
        },
        {
          id: 1,
          name: "开启光幕"
        },
      ],

      fullscreenLoading: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addGoodsVisible: false, //控制添加商品页面显示与隐藏
      title: "预览",
      date: "",
      year: "",
      month: "",
      day: "",
      goodsStatus: "", //商品类型
      fileList: [], //上传文件列表
      formData: "", //上传文件的参数
      payway: [
        {key: "全部订单", value: 0},
        {key: "已完成订单", value: 1},
        {key: "已取消订单", value: 2},
        {key: "已退款订单", value: 3},
      ],
      goodsTypeList: [], //商品类型列表
      orderList: "", //订单列表
      goodName: "", //商品名称
      goodsList: [], //商品列表
      options: [
        {label: "是", value: 1},
        {label: "否", value: 0},
      ], //预下架选项
      editForm: {
        alarmInventory: "",
        barcode: "",
        costPrice: "",
        inventoryStock: "",
        name: " ",
        platformGoodsId: "",
        preTakedown: "",
        salePrice: "",
        stock: "",
        storeId: "",
        typeId: "",
        url: "",
        vipPrice: "",
        yzsGoodsChannelList: [],
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      // 上传文件参数
      name: encodeURIComponent(
        JSON.parse(localStorage.getItem("userInfo")).name
      ),
      multiple: false,
      storeId: "",
      uploadUrl: "",
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.uploadUrl = this.$api.OurUpLoadUrl + '/common/uploadFile'
    // this.getdata(this.formInline);
    this.getGoodsType(); //获取商品类型列表
    this.getData(); //获取商品列表
    this.storeId = localStorage.getItem("storeId")
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleSuccess() {
      console.log('success');

    },
    addNewGoods() {
      this.editFormVisible = true;
      this.editForm = {
        alarmInventory: "",
        barcode: "",
        costPrice: "",
        inventoryStock: "",
        name: " ",
        platformGoodsId: "",
        preTakedown: "",
        salePrice: "",
        stock: "",
        storeId: "",
        typeId: "",
        url: "",
        vipPrice: "",
        yzsGoodsChannelList: [],
      }
    },

    removeDomain(item) {
      var index = this.editForm.yzsGoodsChannelList.indexOf(item)
      if (index !== -1) {
        this.editForm.yzsGoodsChannelList.splice(index, 1)
      }
    },
    addDomain() {
      this.editForm.yzsGoodsChannelList.push({
        value: '',
        openTime: 5,
        key: Date.now()
      });
    },

    //获取商品类型列表
    getGoodsType() {
      getGoodsTypeList().then((res) => {
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        //在数组开头添加一个元素
        res.data.unshift({key: "所有", value: ""});
        this.goodsTypeList = res.data;
      });
    },
    //获取商品列表
    getData() {
      this.loading = true;
      //转化日期的格式
      const selectedDate = new Date(this.date);
      this.year = selectedDate.getFullYear();
      this.month = selectedDate.getMonth() + 1; // 月份从0开始，所以要加1
      this.day = selectedDate.getDate();
      getGoodsList({
        name: this.goodName,
        pageNo: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        storeId: localStorage.getItem("storeId"),
        typeId: this.goodsStatus,
      }).then((res) => {
        //改变数组里元素的某个属性
        // res.data.records.forEach((item)=>{
        //   item.payMethod = item.payMethod == 0 ? '微信' : '支付宝'
        //   item.orderStatus = item.orderStatus == 1 ? '已完成' : '生成中'
        //   item.newContent = item.content.replace(/\\n/g, '<br>')
        // })
        this.goodsList = res.data.data.records;
        this.loading = false;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.data.data.total;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.formInline.limit = parm.pageSize;
      // this.getdata(this.formInline)
      this.getData();
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getData();
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.originUrl = row.imageUrl
      //获取商品详情
      getGoodsDetail({
        storeGoodsId: row.id,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        this.editForm = res.data;
      });
      console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm() {
      //修改商品信息

      if (this.editForm.id == null) {

        this.editForm.storeId = localStorage.getItem("storeId")
        addGoodsByBarcode(this.editForm).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "商品信息添加成功!",
            });
            this.editFormVisible = false;
            this.getData();
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        });
      } else {


        this.editForm.storeId = localStorage.getItem("storeId")
        editGoodsInfo(this.editForm).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "商品信息修改成功!",
            });
            this.editFormVisible = false;
            this.getData();
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        });
      }

    },
    //点击添加商品
    addGoods() {
      this.addGoodsVisible = true;
    },
    // 删除公司
    deleteGood(index, row) {
      const _this = this;
      console.log(row, "7777");
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //判断库存是否为0
          if (row.stock != 0) {
            this.$message({
              type: "info",
              message: "库存不为0，不能删除",
            });
            return;
          }
          deleteGoods({
            platformGoodsId: row.id,
            storeId: localStorage.getItem("storeId"),
          })
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "已删除!",
                });
                console.log("888888");
                _this.getData();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      console.log(333333);
      this.editFormVisible = false;
      this.addGoodsVisible = false;
      this.fileList = [];
      this.$refs[formName].resetFields();
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
      console.log(fileList, "sb");
    },
    // 上传图片文件成功的钩子
    handlePictureSuccess(response, file, fileList) {
      console.log(response, file, fileList);
      //弹窗成功提示
      this.$message({
        message: "上传成功",
        type: "success",
      });
      //将返回的图片地址赋值给imageUrl
      console.log(response, '33333')
      this.editForm.url = response.urls;
      // 处理上传成功的逻辑
    },
    //移除图片的钩子
    handlePictureRemove(file, fileList) {
      console.log(file, fileList);
      this.editForm.url = '';
    },
    // 上传文件之前的钩子
    beforeUpload(file) {
      console.log(file);
      const extension = file.name.split(".").pop().toLowerCase();
      const isExcel = ["xlsx", "xls"].includes(extension);
      if (!isExcel) {
        this.$message.error("只能上传Excel文件!");
      }
      return isExcel;
    },
    // 上传文件个数超过限制的钩子
    submitUpload() {
      this.$refs.upload.submit();
    },
    //上传文件的接口
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    // 上传失败钩子
    handleError(err, file, fileList) {
      this.$message.error(err.errormsg);
    },
    //
    submitAdd() {
      //显示loading
      this.fullscreenLoading = true;
      let formData = new FormData();
      formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
      //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
      // formData.append("title", this.title);
      this.$axios
        .post(this.$api.OurUpLoadUrl + "/common/upload/SGoodsexcel", formData, {
          "Content-Type": "multipart/form-data;charset=utf-8",
          // "userName": this.name // 添加"userName"字段，替换为你所需的用户名
          headers: {
            "Content-Type": "multipart/form-data;charset=utf-8",
            userName: this.name, // 添加"userName"字段，替换为你所需的用户名
            storeId: localStorage.getItem("storeId"),
            businessId:localStorage.getItem("userId"),

          },
        })
        .then((res) => {
          console.log(res, "上传成功");
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.fullscreenLoading = false;
            this.closeDialog();
          } else {
            this.$notify({
              title: "失败",
              message: "提交失败",
              type: "error",
              duration: 1000,
            });
            this.fullscreenLoading = false;
          }
        })
        .catch((err) => {
          this.$notify({
            title: "失败",
            message: "提交失败",
            type: "error",
            duration: 1000,
          });
          this.fullscreenLoading = false;
        });
    },
    //导出商品接口
    exportGoods() {
      this.$confirm("确定导出商品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(
              this.$api.OurUpLoadUrl + `/common/StoreExportGoods?store=${localStorage.getItem(
                "storeId"
              )}`,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  storeId: localStorage.getItem("storeId"),

                },
                responseType: "blob",
              }
            )
            .then(async (res) => {
              const isLogin = await blobValidate(res);
              if (res.status == 200) {
                if (isLogin) {
                  console.log(new Blob([res]));
                  const blob = new Blob([res.data]);
                  console.log("blob1111", blob);
                  saveAs(blob, `商品列表_${new Date().getTime()}.xlsx`);
                  this.$message({
                    type: "success",
                    message: "导出成功",
                  });
                } else {
                  const resText = await res.text();
                  const rspObj = JSON.parse(resText);
                  const errMsg =
                    errorCode[rspObj.code] ||
                    rspObj.msg ||
                    errorCode["default"];
                  this.$message.error(errMsg);
                }
                this.$modal.closeLoading();
              } else {
                this.$message.error("导出失败");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.updataBox {
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>







// WEBPACK FOOTER //
// src/views/goods/Goods.vue